<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center">
      <b-form-group class="w-1" label="Поиск">
        <b-form-input placeholder="Поиск" />
      </b-form-group>
      <b-button class="float-right" variant="primary">
        {{ $t("Добавить") }}
      </b-button>
    </div>
    <b-table :fields="fields" :items="GET_ROLE_LIST.results">
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>
      <template #empty>
        <div class="text-center">{{ $t("general.no_records_to_show") }}</div>
      </template>
      <template #cell(name)="{item}">
        <span>{{ item.name && item.name[$i18n.locale] }}</span>
      </template>
      <template #cell(role_objects)="{item}">
        <b-button variant="success" size="sm" @click="openModal(item)">
          <feather-icon icon="ListIcon" />
        </b-button>
      </template>
      <template #cell(payment_type)="{item}">
        <!-- <div class="d-flex align-items-center">
          <span class="mr-1">Банковский</span>
          <b-form-checkbox v-model="item.is_payment_bank" disabled />
        </div>
        <div class="d-flex align-items-center">
          <span class="mr-1">Бартер</span>
          <b-form-checkbox v-model="item.is_payment_barter" disabled />
        </div>
        <div class="d-flex align-items-center">
          <span class="mr-1">Наличный</span>
          <b-form-checkbox v-model="item.is_payment_cash" disabled />
        </div> -->

        <div class="d-flex align-items-center">
          <div class="d-flex flex-column mr-1">
            <span>Банковский:</span>
            <span>Бартер:</span>
            <span>Наличный:</span>
          </div>
          <div>
            <b-form-checkbox v-model="item.is_payment_bank" disabled />
            <b-form-checkbox v-model="item.is_payment_barter" disabled />
            <b-form-checkbox v-model="item.is_payment_cash" disabled />
          </div>
        </div>
      </template>
      <template #cell(actions)="{item}">
        <div class="d-flex">
          <b-button
            variant="primary"
            size="sm"
            @click="
              $router.push({
                name: 'permissions_details',
                params: {
                  role: JSON.stringify({ id: item.id, name: item.name }),
                },
              })
            "
          >
            <feather-icon icon="ChevronRightIcon" />
          </b-button>
          <b-button variant="warning" class="mx-50" size="sm">
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button variant="danger" size="sm">
            <feather-icon icon="TrashIcon" />
          </b-button>
        </div>
      </template>
    </b-table>
    <ObjectsModal :objectsList="objectsList" @saveClick="saveClick" />
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BButton,
  BTable,
  VBModal,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import ObjectsModal from "./components/ObjectsModal.vue";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BTable,
    BFormCheckbox,
    ObjectsModal,
  },

  directives: {
    "b-modal": VBModal,
  },

  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Название",
        },
        {
          key: "role_objects",
          label: "Разрешенные объекты",
        },
        {
          key: "payment_type",
          label: "Тип оплаты",
        },
        {
          key: "actions",
          label: "Действия",
        },
      ],
      objectsList: [],
    };
  },

  computed: {
    ...mapGetters("administration", ["GET_ROLE_LIST"]),
  },

  methods: {
    ...mapActions("administration", ["getPermissionRoles", "updateRoleObject"]),

    openModal(item) {
      this.objectsList = item.role_objects;
      this.$nextTick(() => this.$bvModal.show("objects-modal"));
    },

    async saveClick(data) {
      await this.updateRoleObject({ data });
      this.getPermissionRoles();
      this.$bvModal.hide("objects-modal");
    },
  },

  mounted() {
    this.getPermissionRoles();
  },
};
</script>
